import React, { useEffect, useRef } from "react";
import { useDragging } from "./use-dragging";

function AngleCircle({ value, onChange, ...props }) {
  const angleCircleRef = useRef();
  const angleCircleCenter = useRef();
  const previousCursorValue = useRef();

  const setAngleCircleCenter = () => {
    const rect = angleCircleRef.current.getBoundingClientRect();
    angleCircleCenter.current = {
      x: rect.x + rect.width / 2,
      y: rect.y + rect.height / 2,
    };
  };

  const changeAngleToPosition = (event) => {
    const { x: centerX, y: centerY } = angleCircleCenter.current;
    event.preventDefault();
    event.target.focus();
    onChange(getAngle(centerX, centerY, event.clientX, event.clientY));
  };

  const { startDrag, isDragging } = useDragging({
    onDragStart: (event) => {
      setAngleCircleCenter();
      changeAngleToPosition(event);
    },
    onDragMove: changeAngleToPosition,
    onDragEnd: changeAngleToPosition,
  });

  useEffect(() => {
    if (isDragging) {
      if (previousCursorValue.current === undefined) {
        previousCursorValue.current = document.body.style.cursor;
      }
      document.body.style.cursor = "grabbing";
    } else {
      document.body.style.cursor = previousCursorValue.current || null;
      previousCursorValue.current = undefined;
    }
  }, [isDragging]);

  return (
    <div
      ref={angleCircleRef}
      onMouseDown={startDrag}
      className="circle-root w-20 h-20 grigora-angle-picker-input__angle-circle"
      style={isDragging ? { cursor: "grabbing" } : undefined}
      {...props}
    >
      <div
        style={value ? { transform: `rotate(${value}deg)` } : undefined}
        className="circle-indicator-wrapper grigora-angle-picker-input__angle-circle-indicator-wrapper"
        tabIndex={-1}
      >
        <div className="circle-indicator grigora-angle-picker-input__angle-circle-indicator" />
      </div>
    </div>
  );
}

function getAngle(centerX, centerY, pointX, pointY) {
  const y = pointY - centerY;
  const x = pointX - centerX;

  const angleInRadians = Math.atan2(y, x);
  const angleInDeg = Math.round(angleInRadians * (180 / Math.PI)) + 90;
  if (angleInDeg < 0) {
    return 360 + angleInDeg;
  }
  return angleInDeg;
}

export default AngleCircle;
